import { render, staticRenderFns } from "./AcessoRapido.vue?vue&type=template&id=e80aec6c&scoped=true&"
import script from "./AcessoRapido.vue?vue&type=script&lang=js&"
export * from "./AcessoRapido.vue?vue&type=script&lang=js&"
import style0 from "./AcessoRapido.vue?vue&type=style&index=0&id=e80aec6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80aec6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VAppBar,VContainer,VImg,VSkeletonLoader,VSpacer,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
